/**
 * Component: Modal
 * ------------------------------------------------------------------------------
 *
 * @namespace modal
 */
import {extendDefaults} from '../helpers/utils';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

/**
 * DOM selectors.
 */
const selectors = {
  showModal: '[js-modal="show"]',
  closeModal: '[js-modal="close"]',
};

/**
 * Export a new modal instance.
 * @param {string} selector - The modal item.
 */
export default (selector, config) => {

  /**
   * Instance default settings.
   */
  const defaults = {
    showModal: selectors.showModal,
    forceOpen: false,
    bodyLock: true,
  };

  /**
   * Instance settings.
   */
  const settings = extendDefaults(defaults, config);

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    modal: document.querySelector(selector),
    showModal: document.querySelectorAll(settings.showModal),
    closeModal: document.querySelectorAll(selectors.closeModal),
  };

  /**
   * Initialise component.
   */
  function init() {
    setClickEvents();
    setEventListeners();

    console.log(`🏗️  ${selector} has been built`)

    if (settings.forceOpen == true) {
      modalOpen();
    }
  }

  /**
   * Set event listeners.
   */
  function setEventListeners() {
    document.documentElement.addEventListener('keydown', handleKeydown);
  }

  /**
   * Set click events on items.
   */
  function setClickEvents() {
    nodeSelectors.showModal.forEach(close => {
      close.addEventListener('click', function (){
        modalOpen();
      });
    });

    nodeSelectors.closeModal.forEach(close => {
      close.addEventListener('click', function (){
        modalClose();
      });
    });
  }

  /**
   * If key press is ESC close modal.
   */
  function handleKeydown(event) {
    if (event.keyCode === 27) {
      modalClose();
    }
  }

  function modalOpen() {
    nodeSelectors.modal.classList.remove('hidden');
    if (settings.bodyLock == true) {
      console.log(settings.bodyLock);
      disableBodyScroll(nodeSelectors.modal);
    }
    Karmoon.EventBus.emit('Modal:Open', nodeSelectors.modal);
  }

  function modalClose() {
    nodeSelectors.modal.classList.add('hidden');
    if (settings.bodyLock == true) {
      console.log(settings.bodyLock);
      enableBodyScroll(nodeSelectors.modal);
    }
    Karmoon.EventBus.emit('Modal:Close', nodeSelectors.modal);
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
    modalOpen,
    modalClose,
  });
};
